/* Alberto Bellini — filterlade, kleurvarianten, zoeksuggesties en gedeelde hulpjes */
(function () {
  'use strict';

  /* ---------- mobiele filterlade ---------- */
  var filters = document.getElementById('filters');
  var sluier = document.getElementById('sluier');

  function filtersDicht() {
    if (!filters) return;
    filters.classList.remove('aan');
    if (sluier) sluier.classList.remove('aan');
    document.body.classList.remove('vast');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-filter-open]') && filters) {
      e.preventDefault();
      filters.classList.add('aan');
      if (sluier) sluier.classList.add('aan');
      document.body.classList.add('vast');
      return;
    }
    if (e.target.closest('[data-filter-sluit]')) { e.preventDefault(); filtersDicht(); return; }
    if (e.target === sluier) filtersDicht();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') filtersDicht(); });

  /* ---------- geld: altijd Nederlands, met duizendpunt ---------- */
  function euro(centen) {
    var n = Math.round(Number(centen) || 0) / 100;
    var d = n.toFixed(2).split('.');
    d[0] = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€ ' + d[0] + ',' + d[1];
  }
  function euroUitTekst(v) {
    var s = String(v == null ? '' : v).replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var n = parseFloat(s);
    return isNaN(n) ? '' : euro(Math.round(n * 100));
  }

  /* ---------- kleuren ----------
     Van specifiek naar algemeen: 'forrest groen' moet eerder matchen dan 'groen'.
     Dezelfde lijst staat in snippets/pnaam.liquid — pas ze samen aan. */
  var KL = ['black-blue combi','forrest groen','forrest green','forest green','army green','antique bruin','rood bruin','donker blauw','donkerblauw','licht blauw','lichtblauw','navy blue','navy blu','baby blu','light green','donker groen','donkergroen','licht groen','lichtgroen','light grey','licht grijs','lichtgrijs','l.grijs','d.grijs','l.blauw','d.blauw','l.bruin','d.bruin','l.groen','d.groen','off white','donker bruin','donkerbruin','licht bruin','lichtbruin','med brown','br-grey','bordeaux','bordo','catstagne','castagne','whiskey','cognac','snuff','taupe','beige','camel','mocha','roast','chai','cloud','terra','ocean','olive','khaki','navy','sand','zand','naturel','bruin','brown','zwart','black','blauw','bleu','blue','grijs','grey','gray','groen','green','rose','creme','crema','wit','white'];
  var MATW = ['suede','suède','nappa','croco','python','leder','leer','leather','lak','patina','calf','handmade','collezione'];
  var HEX = {
    'zwart':'#1A1714','black':'#1A1714',
    'wit':'#F2EFE8','white':'#F2EFE8','off white':'#EDE7DA','creme':'#ECE5D8','crema':'#ECE5D8','cloud':'#D3D7DA',
    'beige':'#D9C9B0','sand':'#D8C3A0','zand':'#D8C3A0','naturel':'#C8B79A','taupe':'#A2917C','camel':'#B98A5A',
    'cognac':'#96562A','snuff':'#A87A50','whiskey':'#8B5A2B','terra':'#A9603E',
    'bruin':'#6D4526','brown':'#6D4526','med brown':'#7A4F2E','licht bruin':'#A3764C','lichtbruin':'#A3764C','l.bruin':'#A3764C',
    'donker bruin':'#4A2F1C','donkerbruin':'#4A2F1C','d.bruin':'#4A2F1C','antique bruin':'#6B4A30','rood bruin':'#7A3B2A',
    'catstagne':'#7A4A2A','castagne':'#7A4A2A',
    'roast':'#5B3A24','mocha':'#6B4A3A','chai':'#B99A72','bordeaux':'#5E2028','bordo':'#5E2028','rose':'#D8A7A0',
    'grijs':'#8D8D8D','grey':'#8D8D8D','gray':'#8D8D8D','licht grijs':'#B8B8B8','lichtgrijs':'#B8B8B8','light grey':'#B8B8B8','l.grijs':'#B8B8B8','d.grijs':'#5F5F5F','br-grey':'#8A7D70',
    'blauw':'#33507A','blue':'#33507A','bleu':'#33507A',
    'donkerblauw':'#1D283C','donker blauw':'#1D283C','d.blauw':'#1D283C','navy':'#1D283C','navy blu':'#1D283C','navy blue':'#1D283C',
    'licht blauw':'#8FB0CF','lichtblauw':'#8FB0CF','l.blauw':'#8FB0CF','baby blu':'#8FB0CF','ocean':'#2E5568',
    'groen':'#4A5A44','green':'#4A5A44','light green':'#93A17E','l.groen':'#93A17E','licht groen':'#93A17E','lichtgroen':'#93A17E',
    'd.groen':'#2F3A2C','donker groen':'#2F3A2C','donkergroen':'#2F3A2C','forrest groen':'#2F3A2C','forrest green':'#2F3A2C','forest green':'#2F3A2C','army green':'#4A5240',
    'olive':'#6B6A3A','khaki':'#A89968'
  };
  var STAART = ['-', '|', ',', '·', ' '];

  function knipStaart(s) {
    while (s.length && STAART.indexOf(s.charAt(s.length - 1)) !== -1) { s = s.substring(0, s.length - 1); }
    return s;
  }
  function knipMateriaal(s) {
    var w = s.split(' ');
    if (w.length > 1 && MATW.indexOf(w[w.length - 1].toLowerCase()) !== -1) { w.pop(); return w.join(' '); }
    return s;
  }
  function ontleed(titel) {
    var t = String(titel || '');
    t = t.replace(/alberto bellini/gi, '').split('||').join('|').split('®').join('');
    t = t.split(/\s+/).join(' ');
    t = knipStaart(t);
    var lt = t.toLowerCase(), kl = '';
    for (var i = 0; i < KL.length; i++) {
      if (lt.length > KL[i].length && lt.substring(lt.length - KL[i].length) === KL[i]) { kl = KL[i]; break; }
    }
    var model = kl ? t.substring(0, lt.length - kl.length) : t;
    model = knipStaart(model);
    model = knipStaart(knipMateriaal(model));
    return { model: model, kleur: kl };
  }
  function nette(titel) {
    var o = ontleed(titel);
    return o.model + (o.kleur ? ' | ' + o.kleur.charAt(0).toUpperCase() + o.kleur.slice(1) : '');
  }
  function ontsnap(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* deel met bellini.js (winkelmandlade) */
  window.BELLINI = window.BELLINI || {};
  window.BELLINI.nette = nette;
  window.BELLINI.euro = euro;

  var cache = {};
  function zoek(term, limiet) {
    var sleutel = term + '|' + limiet;
    if (cache[sleutel]) return cache[sleutel];
    cache[sleutel] = fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=' + limiet)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { try { return j.resources.results.products || []; } catch (e) { return []; } })
      .catch(function () { return []; });
    return cache[sleutel];
  }

  /* ---------- kleurvarianten onder de kaart ---------- */
  function vul(el) {
    var model = el.getAttribute('data-model');
    var eigen = (el.getAttribute('data-kleur') || '').toLowerCase();
    if (!model || el.dataset.klaar) return;
    el.dataset.klaar = '1';
    zoek(model, 10).then(function (lijst) {
      var gezien = {}, uit = [];
      lijst.forEach(function (p) {
        var o = ontleed(p.title);
        var m = o.model.toLowerCase();
        if (m !== model || !o.kleur || gezien[o.kleur]) return;
        gezien[o.kleur] = 1;
        uit.push({ kleur: o.kleur, url: p.url, hex: HEX[o.kleur] || '#C9C1B5' });
      });
      if (uit.length < 2) return;
      var toon = uit.slice(0, 6), rest = uit.length - toon.length, html = '';
      toon.forEach(function (k) {
        html += '<a href="' + ontsnap(k.url) + '" title="' + ontsnap(k.kleur) + '" aria-label="' + ontsnap(k.kleur) + '" style="background:' + k.hex + '"' + (k.kleur === eigen ? ' class="aan"' : '') + '></a>';
      });
      if (rest > 0) html += '<span class="meer">+' + rest + '</span>';
      el.innerHTML = html;
    });
  }

  function startKleuren() {
    var vakken = document.querySelectorAll('.kaart .kleuren[data-model]');
    if (!vakken.length || !window.fetch) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var vak = e.target.querySelector('.kleuren[data-model]');
          if (vak) vul(vak);
        });
      }, { rootMargin: '300px' });
      Array.prototype.forEach.call(vakken, function (v) {
        var kaart = v.closest ? v.closest('.kaart') : null;
        if (kaart) io.observe(kaart); else vul(v);
      });
    } else {
      Array.prototype.forEach.call(vakken, vul);
    }
  }

  /* ---------- zoeksuggesties ---------- */
  function startZoeken() {
    var veld = document.getElementById('zoekveld');
    var bak = document.getElementById('zoeksuggesties');
    if (!veld || !bak || !window.fetch) return;
    var wacht;
    veld.addEventListener('input', function () {
      var term = veld.value.trim();
      clearTimeout(wacht);
      if (term.length < 2) { bak.classList.remove('aan'); bak.innerHTML = ''; return; }
      wacht = setTimeout(function () {
        zoek(term, 6).then(function (lijst) {
          if (!lijst.length) {
            bak.innerHTML = '<p class="mini" style="padding:16px 0">Niets gevonden voor “' + ontsnap(term) + '”. Probeer een model, een kleur of een maat.</p>';
            bak.classList.add('aan');
            return;
          }
          bak.innerHTML = lijst.map(function (p) {
            var beeld = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var prijs = euroUitTekst(p.price);
            return '<a href="' + ontsnap(p.url) + '">' +
              (beeld ? '<img src="' + ontsnap(beeld) + '" alt="" loading="lazy">' : '<span></span>') +
              '<span class="nm">' + ontsnap(nette(p.title)) + '</span>' +
              '<span class="pr prijs">' + prijs + '</span></a>';
          }).join('') + '<a class="alles" href="/search?q=' + encodeURIComponent(term) + '">alle resultaten voor “' + ontsnap(term) + '”</a>';
          bak.classList.add('aan');
        });
      }, 220);
    });
  }

  function start() { startKleuren(); startZoeken(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();